// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {
    const productCards = document.querySelectorAll('.product-card');

    // Función para observar los elementos y aplicar la animación
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('scroll-animation');
                }
            });
        },
        { threshold: 0.2 } // Activa la animación cuando el 20% del elemento es visible
    );

    // Observar cada tarjeta de producto
    productCards.forEach((card) => {
        observer.observe(card);
    });
});
